import React, { useState, useEffect } from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";
import calc from "../../../utils/calculation";

import lbl from "../../../data/Labels.json";

const ContractsList = ({ data }) => {
  const columns = [
    { path: "id", label: "شماره" },
    { path: "entry_year", label: "سمستر" },
    { path: "salary_per_hour", label: "معاش فی ساعت" },
    { path: "second_job", label: "وظیفه دوم", content: ({second_job}) => second_job == 1 ? "بلی" : second_job == 0 ? "نخیر" : "" },
    { path: "inserted_by", label: "ثبت کننده" },
    {
      path: "option",
      content: (e) => (
          <Option
              Edit={{ form: "teacher-contract-form", cache: e.teacher, edit: e }}
              Delete={{ route: "teachers/contracts", id: e.salary_id }}
          />
      ),
    },
  ];

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Contracts}</p>
      <Table
        data={data}
        columns={columns}
      />
    </div>
  );
};

export default ContractsList;
